<template>
	<div class="container-scroll">
		<div class="time-order" v-for="(period, index) in periodDividedChats" :key="index" v-show="period.chats?.length">
			<div class="fixed-header">
				<p class="title-day">{{ period.title }}</p>
			</div>
			<div class="chat-list">
				<div class="item-list" :class="{active: activeChat(chat)}" v-for="(chat, idx) in period.chats" :key="idx" @click.stop="clickChat(chat)">
					<p>{{ chat.name }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {useOpenAIChatsStore} from "@/console-new/stores";
export default {
	setup() {
		let openAIChatsStore = useOpenAIChatsStore();
		return { openAIChatsStore };
	},
	name: "ChatList",
	emits: ["clicked-chat"],
	props: {
		periodDividedChats: {
			type: Object,
			required: true,
		},
	},
	methods: {
		clickChat(chat) {
			if(this.openAIChatsStore.loadingChats) {
				return
			}
			this.openAIChatsStore.activeChatId = chat.ai_chat_id;
			let chatMessages = this.openAIChatsStore.activeChat?.messages || [];
			if(!chatMessages?.length) {
				this.openAIChatsStore.getChatMessages(chat.ai_chat_id);
			}
			this.$emit("clicked-chat");
		},
		activeChat(chat) {
			return this.openAIChatsStore?.activeChatId === chat?.ai_chat_id;
		}
	},
	created() {
		if(this.openAIChatsStore.activeChatId) {
			this.openAIChatsStore.activeChatId = null;
		}
	}
};
</script>

<style scoped lang="scss">
.container-scroll {
	height: 100%;
	max-height: calc(100% - 194px);
	overflow: auto;
	.time-order {
		.fixed-header {
			position: sticky;
			top: 0;
			z-index: 2;
			padding: 10px 0;
			background-color: var(--color-bg-primary-1);
			.title-day {
				font-weight: 600;
			}
		}
		.chat-list {
			.item-list {
				border: 1px solid transparent;
				padding: 5px 10px;
				border-radius: 13px;
				transition: background-color 0.3s $transition, border 0.3s $transition;
				min-height: 42px;
				display: flex;
				align-items: center;
				cursor: pointer;
				.item-link {
					&:after {
						display: none;
					}
				}
				p, a {
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
				&:hover {
					background-color: var(--color-bg-primary-2);
				}
				&.active {
					border: 1px solid var(--color-primary);
					background-color: var(--color-bg-primary-2);
				}
			}
		}
	}
}
</style>